export default "__VITE_ASSET__DYAsazzN__"